<template>
  <SRideTypeSelection
    :appConfig="appConfig"
    :rideType="getRideType"
    :animalsTransportation="getAnimalsTransportation"
    :availableShuttleType="getAvailableShuttleType"
    @setRideType="setRideType"
  />
</template>
<script lang="ts">
export default {
  name: 'RideTypeSelection',
};
</script>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { SRideTypeSelection } from '@slg/web-customer-shared';
import importedAppConfig from '@/appConfig';
import { useStore } from '@/composables';

const emit = defineEmits(['clearBookingRequestError']);
const store = useStore();
const appConfig = ref<Record<string, any>>({});
appConfig.value = importedAppConfig;

const getAnimalsTransportation = computed(() => store.getters['booking/getAnimalsTransportation']);
const getRideType = computed(() => store.getters['booking/getRideType']);
const getAvailableShuttleType = computed(() => store.getters['opsZone/getAvailableShuttleType']);

function setRideType(newType: string) {
  store.commit('booking/setRideType', newType);
  emit('clearBookingRequestError');
}
</script>

<style scoped lang="scss">
</style>
